import React, {
	CSSProperties,
	FunctionComponent,
	SVGProps,
	useMemo,
} from 'react';
import styled from 'styled-components';

import { MediaDimensions } from '../../stores/types/types';

type ReqMediaDimensions = Required<MediaDimensions>;

type ImageSrcOnly = {
	imageSrc: string;
	imageComponentSvg?: never;
};

type ImageComponentOnly = {
	imageSrc?: never;
	imageComponentSvg: FunctionComponent<
		SVGProps<SVGSVGElement> & { title?: string | undefined }
	>;
};

type ImageFrameOptionalProps = {
	altText?: string;
	backgroundColor?: CSSProperties['backgroundColor'];
	borderRadius?: CSSProperties['borderRadius'];
	objectFit?: CSSProperties['objectFit'];
	frameSize?: ReqMediaDimensions;
	imageSize?: ReqMediaDimensions;
};

type ImageFrameProps = (ImageSrcOnly | ImageComponentOnly) & ImageFrameOptionalProps;

const StyledFrame = styled.div`
	display: flex;
	justify-content: center;
	align-items: center;
	overflow: hidden;
`;

const StyledImage = styled.img`
	inset: auto !important;
`;

export default function ImageFrame({
	imageSrc,
	imageComponentSvg: ImageComponentSvg,
	altText = 'Framed image',
	backgroundColor = 'transparent',
	borderRadius = 16,
	objectFit = 'contain',
	frameSize = { height: 52, width: 52 },
	imageSize = { height: 52, width: 52 },
}: ImageFrameProps): JSX.Element {
	const imageComponentSvgMemo = useMemo((): JSX.Element => {
		if (ImageComponentSvg) {
			return (
				<ImageComponentSvg
					fill={backgroundColor}
					style={{ ...imageSize, objectFit }}
					height={imageSize.height}
					width={imageSize.width}
				/>
			);
		}

		return <></>;
	}, [ImageComponentSvg]);

	return (
		<StyledFrame
			className="image-frame"
			style={{ ...frameSize, backgroundColor, borderRadius }}
		>
			{imageSrc && !ImageComponentSvg && (
				<StyledImage
					src={imageSrc}
					style={{ ...imageSize, objectFit }}
					alt={altText}
				/>
			)}
			{ImageComponentSvg && !imageSrc && (
				imageComponentSvgMemo
			)}
		</StyledFrame>
	);
}
